import React from 'react';
import { CalendarIcon, ClockIcon, ExternalLinkIcon } from 'lucide-react';
// The 30-minute strategy session lives on Calendly. Rather than embedding the
// scheduler (which loads heavy third-party code on the homepage and can throw
// opaque cross-origin errors), we link out to it — it opens in a new tab.
const CALENDLY_URL = 'https://calendly.com/liam-scalefinancestrategies/30min';
export function ContactSection() {
  return <section id="contact" className="py-24 bg-[#f8f9fb] dark:bg-[#0f1629] border-t border-slate-100 dark:border-white/5 transition-colors duration-300 relative z-10" data-id="element-43" data-mp="3d8ugzbc74fvw">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44" data-mp="346l9kuc852mq">
        <div className="text-center mb-16" data-id="element-45" data-mp="388yclazl6mft">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white dark:bg-white/5 border border-slate-200 dark:border-white/10 shadow-sm dark:shadow-none mb-6" data-id="element-46" data-mp="387wyexn9xjtv">
            <span className="text-sm font-medium text-primary-600 dark:text-primary-400" data-id="element-47" data-mp="1wv4a5wtozdik">
              Get Started
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4" data-id="element-48" data-mp="7nzkje0pk5zy">
            Map Your Next Move
          </h2>
          <p className="text-lg text-slate-500 dark:text-slate-400 max-w-2xl mx-auto" data-id="element-49" data-mp="gn34slbm2rg1">
            Choose a time that suits you. Complimentary 30-minute strategy
            session.
          </p>
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-50" data-mp="qjz6o8708fbm">
          <div className="bg-white dark:bg-[#1a2035] border border-slate-200 dark:border-white/10 rounded-2xl p-8 sm:p-10 shadow-sm dark:shadow-none text-center transition-colors duration-300" data-id="element-51" data-mp="qio0y2u00xhv">
            <div className="w-16 h-16 rounded-2xl bg-primary-50 dark:bg-primary-500/10 border border-primary-100 dark:border-primary-500/20 flex items-center justify-center mx-auto mb-6" data-id="element-52" data-mp="10cwumturmwhm">
              <CalendarIcon className="w-8 h-8 text-primary-600 dark:text-primary-400" data-id="element-53" data-mp="19bs1m85mwalz" />
            </div>
            <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-2" data-id="element-54" data-mp="14acemajwbu0y">
              Book your strategy session
            </h3>
            <p className="text-slate-500 dark:text-slate-400 mb-6 max-w-md mx-auto" data-id="element-55" data-mp="6xawj8kpptri">
              Pick a time that works for you and we'll map out your next move
              together. It's free, and there's no obligation.
            </p>

            <div className="inline-flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400 bg-slate-50 dark:bg-white/5 border border-slate-200 dark:border-white/10 rounded-full px-4 py-2 mb-8" data-id="element-56" data-mp="frpan7tiay91">
              <ClockIcon className="w-4 h-4 text-primary-500" data-id="element-57" data-mp="pqokuutx71y5" />
              <span data-id="element-58" data-mp="uoq3jenfoz93">30 minutes · Complimentary</span>
            </div>

            <div data-id="element-59" data-mp="yp0aoumypvpj">
              <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-gradient-to-r from-accent-500 to-primary-500 text-white font-semibold text-lg hover:shadow-[0_0_30px_rgba(20,184,166,0.35)] hover:scale-[1.02] transition-all" data-id="element-60" data-mp="ypjnjwxr9twp">
                Book a Strategy Session
                <ExternalLinkIcon className="w-5 h-5" data-id="element-61" data-mp="2o4aw0n26s4d2" />
              </a>
            </div>
            <p className="text-xs text-slate-400 dark:text-slate-500 mt-4" data-id="element-62" data-mp="2j7khi4615gtr">
              Opens our booking page in a new tab.
            </p>
          </div>
        </div>
      </div>
    </section>;
}